import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { AdminUserService } from '../../user/admin-user.service';

const API_URL = environment.apiUrl;

@Injectable()
export class AuthAdminService {
  constructor(
    private http: HttpClient,
    private adminUserService: AdminUserService
  ) {}

  authenticate(login: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        accept: 'application/ld+json',
      }),
      observe: 'response',
    } as any;

    return this.http
      .post(API_URL + '/admin_login_check', login, httpOptions)
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.adminUserService.setToken(authToken);
        })
      );
  }

  changePassword(body: any, userId: number, needRefresh = true) {
    return this.http
      .put(API_URL + '/admin-users/' + userId + '/change-password', body, {
        observe: 'response',
      })
      .pipe(
        tap((res: any) => {
          if (needRefresh) {
            const authToken = res.body.token;
            this.adminUserService.setToken(authToken);
          }
        })
      );
  }

  refreshToken() {
    return this.http
      .get(API_URL + '/admin-refresh-token', { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.adminUserService.setToken(authToken);
        })
      );
  }

  forgotPassword(body: any) {
    return this.http.post(API_URL + '/admin-resetting-password-request', body);
  }

  forgotPasswordVerifyToken(token: string) {
    return this.http.get(
      API_URL + '/admin-resetting-password-verify-token/' + token,
      {}
    );
  }

  forgotPasswordReset(body: any) {
    return this.http.post(API_URL + '/admin-resetting-password-reset', body);
  }

  editUser(body: any, userId: number) {
    return this.http.put(API_URL + '/admin-users/' + userId, body);
  }

  authConnectVerifyAccess(email: string, returnUrl: string) {
    return this.http.get(API_URL + '/admin-connect-verify-access/' + email, {params: {returnUrl: btoa(returnUrl || '')}});
  }
}
